<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <!--
    <v-container grid-list-md fluid>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
          Filtros
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_fecha_inicial"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_inicial"
                label="Fecha Inicial"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="fecha_inicial" @input="menu_fecha_inicial = false">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_fecha_final"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_final"
                label="Fecha Final"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="fecha_final" @input="menu_fecha_final = false">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-select
            v-model="selected_condominio"
            :items="condominios"
            item-text="nombre"
            label="Condominio"
            return-object
            required
          ></v-select>
        </v-flex>
        <v-flex xs12 sm2 md2>
          <v-select
            v-model="selected_subcondominio"
            :items="subcondominios"
            item-text="nombre"
            label="Subcondominio"
            return-object
            required
          ></v-select>
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-combobox
            v-model="selected_vivienda"
            :items="viviendas"
            :loading="viviendasIsLoading"
            :search-input.sync="viviendaSearch"
            :hide-no-data="!viviendaSearch"
            hide-selected
            item-text="n_vivienda"
            item-value="n_vivienda"
            label="Vivienda"
            placeholder="Comience a escribir para buscar"
            return-object
          >
          </v-combobox>
        </v-flex>
        <v-flex xs12 sm1 md1>
          <v-btn
            color="primary"
            dark
            @click="clear_filters"
          >
            Limpiar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    -->
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :expand="expand"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr @click="detalles_acceso(props)">
          <td class="text-xs-left px-2">
            {{ props.item.nombre_operador_walkin }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.nombre_operador }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.fecha_esperada }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.vigente_hasta }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.desarrollo }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.subcondominio }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.vivienda }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.nombres_residente }} {{ props.item.apellidos_residente }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.asunto }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.nombres_visitante }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.apellidos_visitante }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.observaciones }}
          </td>
          <td class="text-xs-left px-1">
            {{ props.item.placas }}
          </td>
          <td v-if="props.item.revocado===true" class="text-xs-center px-1">SI</td>
          <td v-else class="text-xs-center px-1">NO</td>
          <td v-if="props.item.qr_code" class="text-xs-center px-1">SI</td>
          <td v-else class="text-xs-center px-1">NO</td>
          <td v-if="props.item.acceso_multiple===true" class="text-xs-center px-1">SI</td>
          <td v-else class="text-xs-center px-1">NO</td>
          <td class="text-xs-center pl-1 pr-2">
            {{ props.item.ultimo_movimiento }}
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card>
          <v-card-title class="headline">Detalle Acceso</v-card-title>
              <v-card-text>
                <span v-if="props.item.acceso_multiple===true">
                  <strong>TIPO</strong>: Acceso Múltiple <br>
                  <strong>FECHA DE VIGENCIA</strong>:&nbsp;
                  {{ formatter_date_range(props.item.fecha_esperada, props.item.vigente_hasta, 'YYYY-MM-DD') }}
                  <br>
                  <strong>HORARIO PERMITIDO</strong>:&nbsp;
                  <span v-if="props.item.acceso_todo_dia==true">Todo el día</span>
                  <span v-else>
                    {{ formatter_time_range(props.item.hora_desde, props.item.hora_hasta) }}
                  </span>
                  <br>
                  <strong>DÍAS PERMITIDOS</strong>: <br>
                  <span>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.lunes==true">
                      Lunes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.martes==true">
                      Martes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.miercoles==true">
                      Miércoles
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.jueves==true">
                      Jueves
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.viernes==true">
                      Viernes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.sabado==true">
                      Sábado
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.domingo==true">
                      Domingo
                    </v-chip>
                  </span>
                  <br>
                </span>
                <span v-else>
                  <strong>TIPO</strong>: Acceso Único<br>
                  <strong>FECHA ESPERADA</strong>:&nbsp;
                  {{ props.item.fecha_esperada }}
                  <br>
                  <strong>VIGENTE HASTA</strong>:&nbsp;
                  {{ props.item.vigente_hasta }}
                  <br>
                </span>
              </v-card-text>
        </v-card>
        <v-timeline>
          <v-timeline-item
            v-for="n in props.item.detalles"
            :key="n.id"
            color="red lighten-2"
            small
          >
            <v-card>
              <v-card-title class="headline">{{n.fecha}}</v-card-title>
              <v-card-text>
                <span v-if="props.item.acceso_multiple===true">
                  <strong>TIPO</strong>: Acceso Múltiple <br>
                  <strong>FECHA DE VIGENCIA</strong>:&nbsp;
                  {{ formatter_date_range(props.item.fecha_esperada, props.item.vigente_hasta, 'YYYY-MM-DD') }}
                  <br>
                  <strong>HORARIO PERMITIDO</strong>:&nbsp;
                  <span v-if="props.item.acceso_todo_dia==true">Todo el día</span>
                  <span v-else>
                    {{ formatter_time_range(props.item.hora_desde, props.item.hora_hasta) }}
                  </span>
                  <br>
                  <strong>DÍAS PERMITIDOS</strong>: <br>
                  <span>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.lunes==true">
                      Lunes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.martes==true">
                      Martes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.miercoles==true">
                      Miércoles
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.jueves==true">
                      Jueves
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.viernes==true">
                      Viernes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.sabado==true">
                      Sábado
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.domingo==true">
                      Domingo
                    </v-chip>
                  </span>
                  <br>
                </span>
                <span v-else>
                  <strong>TIPO</strong>: Acceso Único<br>
                  <strong>FECHA ESPERADA</strong>:&nbsp;
                  {{ props.item.fecha_esperada }}
                  <br>
                  <strong>VIGENTE HASTA</strong>:&nbsp;
                  {{ props.item.vigente_hasta }}
                  <br>
                </span>
                <strong>PORTICO</strong>: {{n.portico}}
                <br>
                <strong>ESTATUS</strong>: {{n.status_acceso}}
                <br>
                <strong>OBSERVACIONES</strong>: {{n.observaciones}}
                <br>
                <v-btn flat icon @click="get_acceso_detalles(props.item, n.id)">
                  <v-icon>description</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogDetalles"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          TIPO:&nbsp;ACCESO&nbsp;
          <span v-if="acceso.acceso_multiple===true">MÚLTIPLE</span><span v-else>ÚNICO</span>
          <v-spacer></v-spacer>
          <v-btn flat icon
                 @click="close_dialog_detalles()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <template v-if="acceso.acceso_multiple===true">
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :value="formatter_date_range(acceso.fecha_esperada, acceso.vigente_hasta, 'YYYY-MM-DD')"
                  label="Fecha de Vigencia"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-if="acceso.acceso_todo_dia==true"
                  value="Todo el día"
                  label="Horario Permitido"
                  readonly
                />
                <v-text-field
                  v-else
                  :value="formatter_time_range(acceso.hora_desde, acceso.hora_hasta)"
                  label="Horario Permitido"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  :value="formatter_dias_vigencia(acceso)"
                  label="Días Permitidos"
                  readonly
                />
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :value="acceso.fecha_esperada"
                  label="Fecha Esperada"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :value="acceso.vigente_hasta"
                  label="Vigente Hasta"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  readonly
                />
              </v-flex>
            </template>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="accesos_detalles.fecha"
                label="Fecha de Movimiento"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="accesos_detalles.portico"
                label="Portico"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="accesos_detalles.status_acceso"
                label="Estatus"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md6>
              <v-text-field
                v-model="accesos_detalles.observaciones"
                label="Observaciones"
                readonly
              />
            </v-flex>
            <template v-show="acceso.revocado==true">
              <v-flex xs12 sm3 md3>
                <v-text-field
                  value="SI"
                  label="Revocado"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="acceso.fecha_revocacion"
                  label="Fecha Revocación"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md6>
                <v-text-field
                  v-model="acceso.motivo_revocacion"
                  label="Motivo Revocación"
                  readonly
                />
              </v-flex>
            </template>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="acceso.desarrollo"
                label="Condominio"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="acceso.subcondominio"
                label="Sub Condominio"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="acceso.vivienda"
                label="Vivienda"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm12 md12>
              <strong>Datos Personales del Contacto</strong>
              <v-divider/>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="acceso.nombres_residente"
                label="Nombre(s)"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="acceso.apellidos_residente"
                label="Apellidos"
                readonly
              />
            </v-flex>
          </v-layout>
          <template
            v-if="accesos_detalles.visitantes &&
                          accesos_detalles.visitantes.length > 0">
            <v-layout row wrap
                      v-for="(visitante, index) in accesos_detalles.visitantes"
                      :key="index">
              <v-flex xs12 sm12 md12>
                <strong>
                  Datos Personales del Visitante No. {{ index + 1 }}
                </strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="visitante.tipo"
                  label="Tipo"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="visitante.empresa"
                  label="Empresa"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.motivo"
                  label="Motivo"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.nombres"
                  label="Nombre(s)"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.apellidos"
                  label="Apellidos"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_rostro!==''">
                <img :src="decode_base64(visitante.foto_rostro)"
                     style="width: 95%"
                     alt="foto_rostro"/>
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_credencial_frente!==''">
                <img :src="decode_base64(visitante.foto_credencial_frente)"
                     style="width: 95%"
                     alt="foto_credencial_frente"/>
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_credencial_trasera!==''">
                <img :src="decode_base64(visitante.foto_credencial_trasera)"
                     style="width: 95%"
                     alt="foto_credencial_trasera"/>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="text-md-left">
                <strong>Datos Personales del Visitante</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="acceso.asunto"
                  label="Asunto"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm5 md5>
                <v-text-field
                  v-model="acceso.nombres_visitante"
                  label="Nombre(s)"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm5 md5>
                <v-text-field
                  v-model="acceso.apellidos_visitante"
                  label="Apellidos"
                  readonly
                />
              </v-flex>
            </v-layout>
          </template>
          <template v-show="accesos_detalles.vehiculos">
            <template v-for="(vehiculo, index) in accesos_detalles.vehiculos">
              <v-layout row wrap :key="index">
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <strong>Datos del Vehículo No. {{ index + 1 }}</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.placas"
                    label="Placas"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.color"
                    label="Color"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.marca"
                    label="Marca"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.modelo"
                    label="Modelo"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_frontal!==''">
                  <img :src="decode_base64(vehiculo.foto_frontal)"
                       style="width: 95%"
                       alt="foto_frontal"/>
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_lateral!==''">
                  <img :src="decode_base64(vehiculo.foto_lateral)"
                       style="width: 95%"
                       alt="foto_lateral"/>
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_trasera!==''">
                  <img :src="decode_base64(vehiculo.foto_trasera)"
                       style="width: 95%"
                       alt="foto_trasera"/>
                </v-flex>
              </v-layout>
            </template>
          </template>
          <v-layout row wrap
                    v-show="accesos_detalles.imagenes &&
                                  accesos_detalles.imagenes.length > 0">
            <v-flex xs12 sm12 md12 class="text-md-left">
              <strong>Imágenes</strong>
              <v-divider/>
            </v-flex>
            <v-flex xs12 sm4 md4
                    v-for="(item,i) in accesos_detalles.imagenes"
                    :key="i">
              <img :src="decode_base64(item.image)"
                   style="width: 95%"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';
import moment from '../../node_modules/moment';

export default {
  data: () => ({
    dialogDetalles: false,
    timer: '',
    menu_fecha_inicial: null,
    fecha_inicial: null,
    fecha_final: null,
    menu_fecha_final: null,
    presearch: '',
    selected_condominio: null,
    selected_subcondominio: null,
    selected_vivienda: null,
    viviendasApiResult: null,
    viviendaSearch: null,
    searchTimer: null,
    accesoId: null,
    porticoSearch: null,
    fecha_esperada: null,
    status_acceso: null,
    hora_esperada: null,
    expand: false,
    loading: true,
    totalItems: 0,
    rowItems: [],
    search: '',
    pagination: {},
    acceso: [],
    headers: [
      {
        text: 'Solicitud De Acceso', value: 'nombre_operador_walkin', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Autorizacion De Acceso', value: 'nombre_operador', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Fecha Esperada', value: 'fecha_esperada', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Vigente Hasta', value: 'vigente_hasta', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Condominio', value: 'desarrollo', sortable: true, class: 'px-2',
      },
      {
        text: 'Sub Condominio', value: 'subcondominio', sortable: true, width: '50px', class: 'px-2',
      },
      {
        text: 'Vivienda', value: 'vivienda', sortable: true, width: '50px', class: 'px-2',
      },
      {
        text: 'Residente', value: 'nombres_residente', sortable: true, class: 'px-4',
      },
      {
        text: 'Asunto', value: 'asunto', sortable: true, class: 'px-2',
      },
      {
        text: 'Nombre Visitante', value: 'nombres_visitante', sortable: true, class: 'px-4',
      },
      {
        text: 'Apellidos Visitante', value: 'apellidos_visitante', sortable: true, class: 'px-4',
      },
      {
        text: 'Observaciones', value: 'observaciones', sortable: true, class: 'px-4',
      },
      {
        text: 'Placas', value: 'placas', sortable: false, class: 'px-1',
      },
      {
        text: 'Revocado', value: 'revocado', sortable: true, class: 'px-1',
      },
      {
        text: 'Con QR', value: 'qr_code', sortable: true, class: 'px-1',
      },
      {
        text: 'Acceso Múltiple', value: 'acceso_multiple', sortable: true, class: 'px-1',
      },
      {
        text: 'Último Evento', value: 'ultimo_movimiento', sortable: false, class: 'pl-1 pr-2',
      },
    ],
  }),
  computed: {
    /*
    folios() {
      return this.$store.getters['historico/accesos_list'];
    },
    is_loading() {
      return this.$store.getters['historico/loading_accesos'];
    },
    */
    condominios() {
      return this.$store.getters['historico/condominios'];
    },
    subcondominios() {
      return this.$store.getters['historico/subcondominios'];
    },
    viviendas() {
      return this.$store.getters['historico/viviendas'];
    },
    viviendasIsLoading() {
      return this.$store.getters['historico/viviendasIsLoading'];
    },
    accesos_detalles() {
      return this.$store.getters['historico/accesos_detalles'];
    },
    getted_detalles() {
      return this.$store.getters['historico/getted_detalles'];
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
          .then((data) => {
            this.rowItems = data.items;
            this.totalItems = data.total;
          });
      },
      deep: true,
    },
    search() {
      this.getDataFromApi()
        .then((data) => {
          this.rowItems = data.items;
          this.totalItems = data.total;
        });
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
    viviendaSearch() {
      // Items have already been loaded
      if (this.viviendas.length > 0) return;
      // Items have already been requested
      if (this.viviendasIsLoading) return;
      this.$store.dispatch('historico/fetchViviendas');
    },
    getted_detalles(val) {
      this.dialogDetalles = val;
    },
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  created() {
    /*
    if (!(this.$store.getters['historico/accesos_list'].length > 0)) {
      this.$store.dispatch('historico/clearAccesosAction');
      this.$store.dispatch('historico/fetchAccesos');
    } else {
      this.$store.commit('historico/fetchedAccesos');
    }
     */
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        const formdata = {
          page,
          rowsPerPage,
          search: this.search,
          sortBy,
          descending,
        };
        this.$store.dispatch('historico/fetchAccesos', formdata)
          .then(() => {
            this.loading = false;
            const items = this.$store.getters['historico/accesos_list'];
            const total = this.$store.getters['historico/accesos_total'];

            this.$store.commit('historico/fetchedAccesos');
            resolve({
              items,
              total,
            });
          });
      });
    },
    clear_filters() {
      this.menu_fecha_inicial = null;
      this.fecha_inicial = null;
      this.menu_fecha_inicial = null;
      this.fecha_final = null;
      this.selected_subcondominio = null;
      this.selected_condominio = null;
      this.selected_vivienda = null;
      this.viviendaSearch = null;
    },
    is_admin() {
      if (getJWTData().user_claims.role === 'admin') {
        return true;
      }
      return false;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    fetchEventsList() {
      if (!this.$store.getters.loading_accesos) {
        this.$store.dispatch('historico/clearAccesosAction');
        this.$store.dispatch('historico/fetchAccesos');
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    set_initial_date() {
      const currentTime = new Date();
      const mm = currentTime.getMonth() + 1; // getMonth() is zero-based
      const dd = currentTime.getDate();
      const hh = currentTime.getHours();
      const min = currentTime.getMinutes();
      const dateArray = [currentTime.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd];
      this.fecha_esperada = dateArray.join('-');
      const hourArray = [(hh > 9 ? '' : '0') + hh, (min > 9 ? '' : '0') + min];
      this.hora_esperada = hourArray.join(':');
    },
    detalles_acceso(val) {
      val.expanded = !val.expanded;
    },
    decode_base64(encoded) {
      const base = 'data:image/jpeg;base64, ';
      if (encoded !== null) {
        return base.concat(encoded);
      }
      return null;
    },
    get_acceso_detalles(value, detalleId) {
      this.acceso = value;
      this.$store.dispatch('historico/fetchAccesoDetalles', detalleId);
    },
    close_dialog_detalles() {
      this.acceso = [];
      this.$store.commit('historico/clearAccesosDetalles');
    },
    formatter_date(fecha, formato = 'DD-MM-YYYY') {
      return moment(fecha).format(formato);
    },
    formatter_time(hora, formato = 'HH:mm') {
      return moment(hora, 'HH:mm:ss').format(formato);
    },
    formatter_date_range(desde, hasta, formato = 'DD-MM-YYYY') {
      return `${this.formatter_date(desde, formato)} al ${this.formatter_date(hasta, formato)}`;
    },
    formatter_time_range(desde, hasta, formato = 'HH:mm') {
      return `${this.formatter_time(desde, formato)} a ${this.formatter_time(hasta, formato)}`;
    },
    formatter_dias_vigencia(acceso) {
      let html = '';
      if (acceso.lunes === true) {
        html += 'Lunes ';
      }
      if (acceso.martes === true) {
        html += 'Martes ';
      }
      if (acceso.miercoles === true) {
        html += 'Miércoles ';
      }
      if (acceso.jueves === true) {
        html += 'Jueves ';
      }
      if (acceso.viernes === true) {
        html += 'Viernes ';
      }
      if (acceso.sabado === true) {
        html += 'Sábado ';
      }
      if (acceso.domingo === true) {
        html += 'Domingo ';
      }
      return html;
    },
  },
};
</script>
